import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
//store
import { RootState } from 'store/ducks';
//components
import Text from 'components/Text';
import Animated from 'components/Animated';
import { Button } from 'components/Button';
import { Visibility } from 'components/Visibility';
import { Column, Row } from 'components/Layout/Grid';
import { ActionButton } from 'components/ModelButton';
import { IsNullOrEmpty } from 'utils/StringNullOrEmpty';

const Toast: React.FC = () => {
  const toast = useSelector((state: RootState) => state.toast);
  const user = useSelector((state: RootState) => state.user);
  const dispatch = useDispatch();

  const closeModal = () => {
    if (toast?.modalInitial && !user?.notViewInitialModal) {
      dispatch({
        type: 'SET_USER_NOT_VIEW_INITIAL_MODAL',
        value: true,
      });
    }

    if (toast.actionButtonClose) toast.actionButtonClose();

    dispatch({ type: 'CLOSE_TOAST' });
  };

  return (
    <Animated
      className="d-flex fixed top-0 right-0 left-0 bottom-0 bg-modal align-center justify-center"
      animationIn="fadeIn"
      animationInDelay="faster"
      animationOut="fadeOut"
      animationOutDelay="faster"
      show={toast?.show}
      style={{ zIndex: 99999999 }}
    >
      <Animated
        animationIn="slideInDown"
        animationInDelay="faster"
        animationOut="slideOutUp"
        animationOutDelay="faster"
        show={toast?.show}
      >
        <Column
          className="bg-white p-4"
          style={{ width: toast?.widthContainer || 420, height: 'auto', borderRadius: 10 }}
        >
          <Visibility visible={toast?.icon}>
            <img
              src={toast?.icon}
              alt=""
              style={{ height: toast?.iconHeight || 120 }}
            />
          </Visibility>

          {toast?.title && (
            <Text
              className={`${toast.important ? 'color-danger' : 'color-blue-gray'} font-bold text-wrap ${toast.component ? 'mb-3' : 'mt-5'} text-center`}
              size={toast?.titleSize || 16}
            >
              {toast.title}
            </Text>
          )}

          {!toast.html && (
            <Text
              className={`color-blue-gray text-wrap
                ${toast?.title !== undefined ? 'mt-1' : 'mt-5'}
                ${toast?.isTextAlignLeft ? "text-left" : "text-center"}`
              }
              size={toast?.descriptionSize || 12}
            >
              {toast?.text}
            </Text>
          )}

          {toast.html && toast.text}

          <Visibility visible={!IsNullOrEmpty(toast.component)}>
            {toast.component}
          </Visibility>

          <Row>
            {toast?.actionButton && (
              <ActionButton
                img=""
                textButton={toast?.buttonActionLabel || 'Sim'}
                className="mt-5 w-40 mx-auto"
                action={() => toast.actionButton()}
                enableWidth={false}
                trackItem={toast.trackItem}
                trackName={toast.trackAction}
                origin="toast"
              />
            )}
            <Button
              onClick={() => closeModal()}
              className="bg-greenDarkViveo mt-5 w-40 mx-auto"
            >
              <Text className="font-bold color-white">
                {toast?.buttonLabel || 'Ok'}
              </Text>
            </Button>
          </Row>
        </Column>
      </Animated>
    </Animated>
  );
};

export default Toast;
